module.exports = __webpack_public_path__ + "static/media/jkms.44cbb64e.png";